(function () {
  let zendeskLoaded = false;
  let zendeskLoading = false;
  let zendeskOpened = false;

  const ZENDESK_KEY = 'a3439747-311f-465f-b8d2-3323c113268f';

  /**
   * FR 站客服就是 Zendesk App，不要再插一份 snippet，也不要露出快牛浮窗。
   * 其他站是快牛转 Zendesk，不要把这份逻辑拷过去。
   */
  const UG_ZENDESK_ONLY = true;

  /**
   * 转接 Zendesk 相关 UI 文案（小语种：仅改此对象对应字段即可）
   */
  const UG_ZENDESK_TRANSFER_COPY = {
    cornerLoading: 'Transfert en cours...',
  };

  const QUICKCEP_LAUNCHER_SELECTOR =
    '#quick-chat-iframe, iframe[src*="quickcep.com"], iframe[src*="chat.quickcep"]';

  function hideQuickCepLauncher(root) {
    (root || document).querySelectorAll(QUICKCEP_LAUNCHER_SELECTOR).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function watchAndHideQuickCepLauncher() {
    hideQuickCepLauncher(document);

    if (watchAndHideQuickCepLauncher.started) return;
    if (typeof MutationObserver !== 'function' || !document.documentElement) return;
    watchAndHideQuickCepLauncher.started = true;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(QUICKCEP_LAUNCHER_SELECTOR)) {
            hideQuickCepLauncher(document);
            return;
          }
          if (node.querySelector && node.querySelector(QUICKCEP_LAUNCHER_SELECTOR)) {
            hideQuickCepLauncher(document);
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function isZendeskLauncherIframe(iframe) {
    var src = iframe.getAttribute('src') || '';
    var title = (iframe.getAttribute('title') || '').toLowerCase();
    var isZd =
      src.indexOf('zdassets') !== -1 ||
      src.indexOf('zendesk') !== -1 ||
      title.indexOf('message') !== -1 ||
      title.indexOf('messagerie') !== -1 ||
      title.indexOf('zendesk') !== -1;
    if (!isZd) return false;
    var w = iframe.offsetWidth || parseInt(iframe.style.width, 10) || 0;
    var h = iframe.offsetHeight || parseInt(iframe.style.height, 10) || 0;
    return w > 20 && w <= 120 && h <= 120;
  }

  function fitZendeskLauncherToBackToTop() {
    var isMobile = window.innerWidth <= 749;
    var target = isMobile ? 44 : 48;

    document.querySelectorAll('iframe').forEach(function (iframe) {
      if (!isZendeskLauncherIframe(iframe)) return;
      var w = iframe.offsetWidth || parseInt(iframe.style.width, 10) || 0;
      if (!w) return;
      var scale = target / w;
      iframe.style.setProperty('transform', 'scale(' + scale + ')', 'important');
      iframe.style.setProperty('transform-origin', 'right bottom', 'important');
    });
  }

  function watchZendeskLauncherSize() {
    fitZendeskLauncherToBackToTop();
    if (watchZendeskLauncherSize.started) return;
    watchZendeskLauncherSize.started = true;

    if (typeof MutationObserver === 'function' && document.documentElement) {
      var observer = new MutationObserver(function () {
        fitZendeskLauncherToBackToTop();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    window.addEventListener('resize', fitZendeskLauncherToBackToTop);
  }

  /* -----------------------------
   加载 Zendesk（只会加载一次）
  ------------------------------*/
  function loadZendesk(onReady, onError) {
    // 主题已嵌入 Zendesk App，或上次已加载完成：复用现有 zE，避免再插一份 snippet
    if (typeof window.zE === 'function') {
      zendeskLoaded = true;
      onReady && onReady();
      return;
    }

    // 正在加载中（防止重复插入 script）
    if (zendeskLoading) {
      waitZendeskReady(onReady, onError);
      return;
    }

    if (UG_ZENDESK_ONLY) {
      waitZendeskReady(function () {
        zendeskLoaded = true;
        onReady && onReady();
      }, onError);
      return;
    }

    zendeskLoading = true;

    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
    script.async = true;

    script.onload = function () {
      console.log('Zendesk script loaded');

      waitZendeskReady(() => {
        zendeskLoaded = true;

        // 初始化：隐藏 launcher
        try {
          zE('messenger', 'hide');
        } catch (e) {
          console.warn('Zendesk init error', e);
        }

        onReady && onReady();
      }, onError);
    };

    script.onerror = function () {
      console.error('Zendesk load failed');
      zendeskLoading = false;
      onError && onError();
    };

    document.head.appendChild(script);
  }

  /* -----------------------------
   等待 zE 可用（带超时）
  ------------------------------*/
  function waitZendeskReady(callback, onError) {
    const interval = 100;
    const timeout = 5000;
    let elapsed = 0;

    const timer = setInterval(function () {
      if (typeof window.zE === 'function') {
        clearInterval(timer);
        callback();
        return;
      }

      elapsed += interval;

      if (elapsed >= timeout) {
        clearInterval(timer);
        console.error('Zendesk init timeout');
        onError && onError();
      }
    }, interval);
  }

  /* -----------------------------
   转接 Zendesk：右下角 loading（左侧白底聊天气泡文案 + 右侧白底 48×48 圆内转圈）
  ------------------------------*/
  function showZendeskTransferCornerLoading() {
    let el = document.getElementById('ug-zendesk-transfer-corner-loading');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ug-zendesk-transfer-corner-loading';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-label', UG_ZENDESK_TRANSFER_COPY.cornerLoading);

      const bubble = document.createElement('div');
      bubble.className = 'ug-ztl-corner-loading-bubble';

      const label = document.createElement('span');
      label.className = 'ug-ztl-corner-loading-text';
      label.textContent = UG_ZENDESK_TRANSFER_COPY.cornerLoading;

      const orb = document.createElement('div');
      orb.className = 'ug-ztl-corner-loading-orb';

      const spinner = document.createElement('span');
      spinner.className = 'ug-ztl-spinner ug-ztl-spinner--corner';
      spinner.setAttribute('aria-hidden', 'true');

      bubble.appendChild(label);
      orb.appendChild(spinner);
      el.appendChild(bubble);
      el.appendChild(orb);

      el.style.cssText = `
        position: fixed;
        right: 18px;
        bottom: 50px;
        z-index: 2147483645;
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 0;
        background: transparent;
        padding: 0;
        pointer-events: none;
      `.trim();
      const style = document.createElement('style');
      style.textContent = `
        #ug-zendesk-transfer-corner-loading .ug-ztl-corner-loading-bubble {
          position: relative;
          display: flex;
          align-items: center;
          margin-right: 6px;
          padding: 7px 13px;
          border-radius: 10px;
          background: #fff;
          box-shadow:
            0 2px 10px rgba(0, 0, 0, 0.1),
            0 1px 3px rgba(0, 0, 0, 0.06);
        }
        #ug-zendesk-transfer-corner-loading .ug-ztl-corner-loading-text {
          font-size: 14px;
          color: #000;
          line-height: 1.3;
          white-space: nowrap;
          text-shadow: 0 0.5px 1px rgba(0, 0, 0, 0.06);
        }
        #ug-zendesk-transfer-corner-loading .ug-ztl-corner-loading-orb {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #fff;
          box-shadow:
            0 2px 10px rgba(0, 0, 0, 0.1),
            0 1px 3px rgba(0, 0, 0, 0.06);
        }
        #ug-zendesk-transfer-corner-loading .ug-ztl-spinner--corner {
          width: 22px;
          height: 22px;
          border: 2px solid #e8e8e8;
          border-top-color: #555;
          border-radius: 50%;
          animation: ug-ztl-spin 0.75s linear infinite;
        }
        @keyframes ug-ztl-spin {
          to {
            transform: rotate(360deg);
          }
        }
        @media screen and (max-width: 749px) {
          #ug-zendesk-transfer-corner-loading {
            right: 16px!important;
            bottom: 42px!important;
          }
        }
      `.trim();
      document.head.appendChild(style);
      document.body.appendChild(el);
    } else {
      el.setAttribute('aria-label', UG_ZENDESK_TRANSFER_COPY.cornerLoading);
      var textEl = el.querySelector('.ug-ztl-corner-loading-text');
      if (textEl) {
        textEl.textContent = UG_ZENDESK_TRANSFER_COPY.cornerLoading;
      }
    }
    el.style.display = 'flex';
  }

  function hideZendeskTransferCornerLoading() {
    const el = document.getElementById('ug-zendesk-transfer-corner-loading');
    if (el) {
      el.style.display = 'none';
    }
  }

  /**
   * 在 Zendesk 消息区域已展示后再回调（仅使用 messenger:on messagesShown）。
   * onReady：messagesShown 或 open 降级；onTimeout：仅兜底计时器触发（用于回开 QuickChat）。
   * @returns {function} 取消监听与超时（在 zE 抛错时调用，防止误触发）
   */
  function whenMessengerReadyForDisplay(opts) {
    var onReady = opts && opts.onReady;
    var onTimeout = opts && opts.onTimeout;
    var timeoutMsSafe = opts && opts.timeoutMs != null ? opts.timeoutMs : 15000;
    var finished = false;
    var unsubs = [];
    var timeoutId = null;

    function cleanupListeners() {
      unsubs.forEach(function (u) {
        if (typeof u === 'function') {
          try {
            u();
          } catch (e) {}
        }
      });
      unsubs = [];
    }

    function finishReady() {
      if (finished) {
        return;
      }
      finished = true;
      cleanupListeners();
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
      onReady && onReady();
    }

    function pushUnsub(u) {
      if (typeof u === 'function') {
        unsubs.push(u);
      }
    }

    timeoutId = setTimeout(function () {
      if (!finished) {
        finished = true;
        cleanupListeners();
        console.warn('[Zendesk] messagesShown 超时，将回开 QuickChat');
        onTimeout && onTimeout();
      }
    }, timeoutMsSafe);

    try {
      pushUnsub(
        zE('messenger:on', 'messagesShown', function () {
          finishReady();
        }),
      );
    } catch (e) {
      console.warn('[Zendesk] messenger:on messagesShown 订阅失败', e);
    }

    // 未挂上 messagesShown 时降级：open 后再等一小段时间（仍视为就绪，走 onReady）
    if (unsubs.length === 0) {
      try {
        pushUnsub(
          zE('messenger:on', 'open', function () {
            setTimeout(function () {
              if (!finished) {
                console.warn('[Zendesk] 降级：仅收到 open，短延迟后视为就绪');
                finishReady();
              }
            }, 600);
          }),
        );
      } catch (e2) {
        console.warn('[Zendesk] messenger:on open 降级订阅失败', e2);
        setTimeout(function () {
          if (!finished) {
            finishReady();
          }
        }, 600);
      }
    }

    return function cancel() {
      if (finished) {
        return;
      }
      finished = true;
      cleanupListeners();
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
    };
  }

  /* -----------------------------
   打开 Zendesk
   options.onOpened：messagesShown（或 open 降级）后再回调
   options.onTimedOut：仅 messagesShown 兜底超时触发（不调用 onOpened）
   options.onFailed：加载/打开失败时回调（仍会执行原有 QuickChat fallback）
  ------------------------------*/
  function openZendesk(userInfo, options) {
    const onOpened = options && options.onOpened;
    const onTimedOut = options && options.onTimedOut;
    const onFailed = options && options.onFailed;
    const messengerWaitMs = options && options.messengerWaitTimeoutMs;

    loadZendesk(
      () => {
        var cancelWait = null;
        try {
          cancelWait = whenMessengerReadyForDisplay({
            timeoutMs: messengerWaitMs,
            onReady: function () {
              onOpened && onOpened();
            },
            onTimeout: function () {
              onTimedOut && onTimedOut();
            },
          });

          // 防重复打开
          if (zendeskOpened) {
            zE('messenger', 'open');
            return;
          }

          zendeskOpened = true;

          // 传递用户信息
          if (userInfo) {
            const fields = [];

            if (userInfo.email) {
              fields.push({ id: 'email', value: userInfo.email });
            }

            if (userInfo.orderId) {
              fields.push({ id: 'order_id', value: userInfo.orderId });
            }

            if (fields.length > 0) {
              zE('messenger:set', 'conversationFields', fields);
            }
          }

          // 打开聊天（就绪时机由 messenger:on messagesShown / 降级 / 超时 决定）
          zE('messenger', 'show');
          zE('messenger', 'open');
        } catch (e) {
          if (cancelWait) {
            cancelWait();
          }
          console.error('Zendesk open error', e);
          onFailed && onFailed();
          // 👉 fallback：回到 QuickChat
          console.warn('Fallback to QuickChat');
          if (window.quickChatApi) {
            window.quickChatApi.chat && window.quickChatApi.chat();
          }
        }
      },
      () => {
        // 👉 fallback：回到 QuickChat
        console.warn('Fallback to QuickChat');
        onFailed && onFailed();
        if (window.quickChatApi) {
          window.quickChatApi.chat && window.quickChatApi.chat();
        }
      },
    );
  }

  /* -----------------------------
   关闭 Zendesk
  ------------------------------*/
  function closeZendesk() {
    if (window.zE) {
      try {
        zE('messenger', 'close');
      } catch (e) {}
    }
  }

  /* -----------------------------
   QuickChat 接入
  ------------------------------*/
  window.quickChatReadyHook = function () {
    console.log('QuickChat Ready');

    if (UG_ZENDESK_ONLY) {
      hideQuickCepLauncher(document);
      return;
    }

    // 👉 转接 Zendesk
    window.quickEmitter.on('goThirdPlatform', function (data) {
      console.log('goThirdPlatform', data);

      try {
        window.quickChatApi && window.quickChatApi.close();
      } catch (e) {}

      showZendeskTransferCornerLoading();

      openZendesk(
        {
          email: window.customerEmail || '',
          orderId: window.lastOrderId || '',
        },
        {
          onOpened: function () {
            hideZendeskTransferCornerLoading();
          },
          onTimedOut: function () {
            hideZendeskTransferCornerLoading();
            closeZendesk();
            try {
              window.quickChatApi && window.quickChatApi.chat && window.quickChatApi.chat();
            } catch (e) {}
          },
          onFailed: function () {
            hideZendeskTransferCornerLoading();
          },
        },
      );
    });

    // 👉 回切 QuickChat
    window.quickEmitter.on('backToQuickChat', function () {
      console.log('Back to QuickChat');

      closeZendesk();

      try {
        window.quickChatApi && window.quickChatApi.chat && window.quickChatApi.chat();
      } catch (e) {}
    });
  };

  function tryOpenZendeskMessenger() {
    if (typeof window.zE !== 'function') return false;
    try {
      zE('messenger', 'open');
      return true;
    } catch (e) {
      console.warn('Zendesk open error', e);
      return false;
    }
  }

  /**
   * FR 站直接开 Zendesk（主题 Zendesk App）。
   * 其他站是快牛转 Zendesk，不要把这份点击逻辑拷过去。
   */
  window.UGopenLiveChat = function (event) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    if (tryOpenZendeskMessenger()) return;

    showZendeskTransferCornerLoading();

    var tries = 0;
    var timer = setInterval(function () {
      if (tryOpenZendeskMessenger()) {
        clearInterval(timer);
        hideZendeskTransferCornerLoading();
        return;
      }

      if (++tries > 25) {
        clearInterval(timer);
        openZendesk(
          {
            email: window.customerEmail || '',
            orderId: window.lastOrderId || '',
          },
          {
            onOpened: function () {
              hideZendeskTransferCornerLoading();
            },
            onTimedOut: function () {
              hideZendeskTransferCornerLoading();
              console.error('Zendesk 未就绪，无法打开客服聊天');
            },
            onFailed: function () {
              hideZendeskTransferCornerLoading();
            },
          },
        );
      }
    }, 200);
  };

  function bindQuickCepTriggers(root) {
    (root || document).querySelectorAll('.js-chat-trigger').forEach(function (btn) {
      if (btn.dataset.quickCepBound === 'true') return;
      btn.dataset.quickCepBound = 'true';
      btn.addEventListener('click', window.UGopenLiveChat);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindQuickCepTriggers(document);
    if (UG_ZENDESK_ONLY) {
      watchAndHideQuickCepLauncher();
      watchZendeskLauncherSize();
    }
  });

  if (UG_ZENDESK_ONLY && document.readyState !== 'loading') {
    watchAndHideQuickCepLauncher();
    watchZendeskLauncherSize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindQuickCepTriggers(event.target);
  });
})();
